import { SITE } from "../../lib/site.js";

export default function Analytics() {
  if (!SITE.gaId) return null;
  const id = SITE.gaId;
  const inline = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${id}',{anonymize_ip:true,send_page_view:false});`;
  return (
    <>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${id}`} />
      <script dangerouslySetInnerHTML={{ __html: inline }} />
    </>
  );
}
